/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useGetBreakpoint } from '../../../../modules/utils';
import clsx from 'clsx';
import { menuDescriptionLimitDesktop } from '../../../../modules/utils/constants/constants';
import { StyledMenuModalHeader } from './MenuModalHeader.styles';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useStore } from '../../../../modules/store/outletDetailsStore';

export const MenuModalHeader = (props: any) => {
  let viewPort = useGetBreakpoint();
  const [isMobileViewPort, setIsMobileViewPort] = useState(viewPort === 'mobile');
  const [menuDescription, setMenuDescription] = useState('');
  const outletData = useStore((state: any) => state.outletData);

  useEffect(() => {
    function handleResize() {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      viewPort = useGetBreakpoint();
      setIsMobileViewPort(viewPort === 'mobile');
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (props?.menuDetails?.description) {
      setMenuDescription(
        props?.menuDetails?.description?.length <= menuDescriptionLimitDesktop
          ? props?.menuDetails?.description
          : props?.menuDetails?.description?.slice(0, menuDescriptionLimitDesktop) + '[...]'
      );
    }
  }, [props?.menuDetails?.description]);

  return (
    <StyledMenuModalHeader className="mr-2">
      {outletData?.basicInformation?.name && (
        <h2 className={clsx(isMobileViewPort ? 'mb-1' : 'mb-2', 'text-left')}>{outletData?.basicInformation?.name}</h2>
      )}
      <div className={clsx(!isMobileViewPort ? 'grid-view' : '', 'text-left')}>
        {props?.menuDetails?.name && (
          <span className="t-font-s">
            {props?.menuDetails?.name}
            {!isMobileViewPort && menuDescription && ` •`}
          </span>
        )}
        {menuDescription && !isMobileViewPort && (
          <span className="t-font-s">
            {' '}
            {props?.showMore
              ? menuDescription
              : props?.menuDetails?.description?.length <= menuDescriptionLimitDesktop
              ? props?.menuDetails?.description
              : props?.menuDetails?.description?.slice(0, menuDescriptionLimitDesktop) + '[...]'}
          </span>
        )}
      </div>
    </StyledMenuModalHeader>
  );
};
